import { render, staticRenderFns } from "./AssignProcessor.vue?vue&type=template&id=68cb1c19&scoped=true"
import script from "./AssignProcessor.vue?vue&type=script&lang=js"
export * from "./AssignProcessor.vue?vue&type=script&lang=js"
import style0 from "./AssignProcessor.vue?vue&type=style&index=0&id=68cb1c19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cb1c19",
  null
  
)

export default component.exports